import React from 'react'
import { component_tool } from '@/tool'
import { Card, Icon, Table } from 'antd'
const { WizComponent, WizButton } = component_tool

import './index.less'

class AcceptanceResults extends WizComponent {

    componentName = 'AcceptanceResults'

    constructor(props) {
        super(props)
        this.state = {
            tabs: ['检核验收结果', '关键KPI', '满意度评估', '摄像头评估'],
            index: 0
        }
    }

    _convert = (data, other) => {
        const stateArr = ['待点评', '待反馈', '无需反馈', '已反馈']
        const exportHeader = {
            headerName: '',
            width: 30,
            field: 'rowIndex',
            hidden: true,
            suppressMovable: true,
            cellStyle: {
                textAlign: 'center',
                padding: '5px 0',
                color: '#595959',
                backgroundColor: '#f0f0f0',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '500',
                boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
            }
        }
        const exportDefProps = {
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }
        let columnsArray = []
        let columnsExportArray = []
        let dataArray = []
        let dataSource = []
        if (data) {
            let { resultList = [] } = data
            resultList.length && resultList.forEach(item => {
                let { name, rateVar = '', elementList = [] } = item
                elementList.length && elementList.map((element, i) => {
                    let row = {
                        mode: name,
                        modeComplianceRate: rateVar,
                        essentialFactor: element.name || '',
                        standardsNumber: element.passNum || 0,
                        substandardNumber: element.noPassNum || 0,
                        complianceRate: element.rateVar || '',
                        results: data.rateVar || '',
                        span: i === 0 ? elementList.length : 0
                    }
                    dataSource.push(row)
                })
            })
        }
        columnsArray.push([{
            title: '评估模块',
            name: 'mode',
            dataIndex: 'mode',
            render: (v, r, i) => {
                const obj = {
                    children: <span dangerouslySetInnerHTML={{ __html: v }}></span>,
                    props: {
                        rowSpan: r.span
                    }
                }
                return obj
            }
        }, {
            title: '模块达标率',
            name: 'modeComplianceRate',
            dataIndex: 'modeComplianceRate',
            render: (v, r, i) => {
                const obj = {
                    children: <span dangerouslySetInnerHTML={{ __html: v }}></span>,
                    props: {
                        rowSpan: r.span
                    }
                }
                return obj
            }
        }, {
            title: '要素情况',
            children: [{
                title: '要素',
                name: 'essentialFactor',
                dataIndex: 'essentialFactor'
            }, {
                title: '达标数',
                name: 'standardsNumber',
                dataIndex: 'standardsNumber'
            }, {
                title: '未达标数',
                name: 'substandardNumber',
                dataIndex: 'substandardNumber'
            }]
        }, {
            title: '达标率',
            name: 'complianceRate',
            dataIndex: 'complianceRate'
        }, {
            title: '评估结果',
            name: 'results',
            dataIndex: 'results',
            render: (v, r, i) => {
                const obj = {
                    children: <span dangerouslySetInnerHTML={{ __html: v }}></span>,
                    props: {
                        rowSpan: i === 0 ? dataSource.length : 0
                    }
                }
                return obj
            }
        }])
        columnsExportArray.push([{
            ...exportHeader
        }, {
            headerName: '评估模块',
            field: 'mode',
            ...exportDefProps
        }, {
            headerName: '模块达标率',
            field: 'modeComplianceRate',
            ...exportDefProps
        }, {
            headerName: '要素情况',
            children: [{
                headerName: '要素',
                field: 'essentialFactor',
                ...exportDefProps
            }, {
                headerName: '达标数',
                field: 'standardsNumber',
                ...exportDefProps
            }, {
                headerName: '未达标数',
                field: 'substandardNumber',
                ...exportDefProps
            }]
        }, {
            headerName: '达标率',
            field: 'complianceRate',
            ...exportDefProps
        }, {
            headerName: '评估结果',
            field: 'results',
            ...exportDefProps
        }])
        dataArray.push(dataSource)
        if (other) {
            let { kpi, camera, satisfaction } = other
            let kpiColumns = [{
                title: '',
                dataIndex: 'cycleName',
                key: 'cycleName',
                width: 260
            }]
            let kpiExportColumns = [{
                ...exportHeader
            }, {
                headerName: '',
                field: 'cycleName',
                ...exportDefProps
            }]
            if (kpi && kpi.headList && kpi.headList.length) {
                kpiColumns = kpiColumns.concat(kpi.headList.map((item, i) => {
                    let { id, name } = item
                    return {
                        title: name,
                        dataIndex: `dataIndex${id}`,
                        key: `dataIndex${id}`,
                        align: 'center'
                    }
                }))
                kpiExportColumns = kpiExportColumns.concat(kpi.headList.map((item, i) => {
                    let { id, name } = item
                    return {
                        headerName: name,
                        field: `dataIndex${id}`,
                        ...exportDefProps
                    }
                }))
            }
            columnsExportArray.push(kpiExportColumns)
            columnsArray.push(kpiColumns)
            if (kpi && kpi.dataList && kpi.dataList.length) {
                let kpiData = kpi.dataList.map((item, i) => {
                    let { trackKpis, ...rest } = item
                    let obj = {}
                    trackKpis && trackKpis.length && trackKpis.forEach(trackKpi => {
                        obj[`dataIndex${trackKpi.kpiId}`] = trackKpi.value
                    })
                    return {
                        ...rest,
                        ...obj
                    }
                })
                dataArray.push(kpiData)
            } else {
                dataArray.push([])
            }
            columnsArray.push([{
                title: '月度',
                dataIndex: 'monthly',
                key: 'monthly',
                align: 'center',
                width: '15%'
            },
            {
                title: '综合得分',
                dataIndex: 'score',
                key: 'score',
                align: 'center',
                width: '15%'
            },
            {
                title: '样本量',
                dataIndex: 'sampleSize',
                key: 'sampleSize',
                align: 'center',
                width: '15%',
            },
            {
                title: '总体满意度',
                dataIndex: 'satisfaction',
                key: 'satisfaction',
                align: 'center',
                width: '15%'
            },
            {
                title: 'KPI达成率',
                dataIndex: 'kpi',
                key: 'kpi',
                align: 'center',
                width: '15%'
            },
            {
                title: '经销商净推荐度NPS',
                dataIndex: 'nps',
                key: 'nps',
                align: 'center',
                width: '15%',
            }])
            columnsExportArray.push([{
                ...exportHeader
            }, {
                headerName: '月度',
                field: 'monthly',
                ...exportDefProps
            }, {
                headerName: '综合得分',
                field: 'score',
                ...exportDefProps
            }, {
                headerName: '样本量',
                field: 'sampleSize',
                ...exportDefProps
            }, {
                headerName: '总体满意度',
                field: 'satisfaction',
                ...exportDefProps
            }, {
                headerName: 'KPI达成率',
                field: 'kpi',
                ...exportDefProps
            }, {
                headerName: '经销商净推荐度NPS',
                field: 'nps',
                ...exportDefProps
            }])
            if (satisfaction && satisfaction.length) {
                dataArray.push(satisfaction.map(o => {
                    let { state, ...rest } = o
                    return {
                        ...rest,
                        state: state ? stateArr[state - 1] : ''
                    }
                }))
            } else {
                dataArray.push([])
            }
            columnsArray.push([{
                title: '月度',
                dataIndex: 'monthly',
                key: 'monthly',
                align: 'center',
                width: '15%'
            },
            {
                title: '总分',
                dataIndex: 'totalScore',
                key: 'totalScore',
                align: 'center',
                width: '15%'
            },
            {
                title: '大区排名',
                dataIndex: 'regionRanking',
                key: 'regionRanking',
                align: 'center',
                width: '15%'
            },
            {
                title: '全国平均分',
                dataIndex: 'nationalAvgScore',
                key: 'nationalAvgScore',
                align: 'center',
                width: '15%'
            },
            {
                title: '大区平均分',
                dataIndex: 'regionAvgScore',
                key: 'regionAvgScore',
                align: 'center',
                width: '15%'
            },
            {
                title: '全国排名',
                dataIndex: 'nationalRanking',
                key: 'nationalRanking',
                align: 'center',
                width: '15%'
            }])
            columnsExportArray.push([{
                ...exportHeader
            }, {
                headerName: '月度',
                field: 'monthly',
                ...exportDefProps
            }, {
                headerName: '总分',
                field: 'totalScore',
                ...exportDefProps
            }, {
                headerName: '大区排名',
                field: 'regionRanking',
                ...exportDefProps
            }, {
                headerName: '全国平均分',
                field: 'nationalAvgScore',
                ...exportDefProps
            }, {
                headerName: '大区平均分',
                field: 'regionAvgScore',
                ...exportDefProps
            }, {
                headerName: '全国排名',
                field: 'nationalRanking',
                ...exportDefProps
            }])
            if (camera && camera.length) {
                dataArray.push(camera.map(o => {
                    let { state, ...rest } = o
                    return {
                        ...rest,
                        state: state ? stateArr[state - 1] : ''
                    }
                }))
            } else {
                dataArray.push([])
            }
        }
        return { columnsArray, columnsExportArray, dataArray }
    }

    _convertExportData = ({ columnsExportArray, dataArray, other, tabs, index }) => {
        if (other) {
            return tabs.map((tab, i) => {
                let rowMergeCell = []
                let rows = dataArray[i]
                let columns = columnsExportArray[i]
                if (i === 0) {
                    rows.map((row, j) => {
                        let { span } = row
                        if (span > 1) {
                            rowMergeCell.push(`A${j + 4}:A${j + 3 + span}`)
                            rowMergeCell.push(`B${j + 4}:B${j + 3 + span}`)
                        }
                        return row
                    })
                    if (rows.length > 1) {
                        rowMergeCell.push(`G${4}:G${3 + rows.length}`)
                    }
                }
                return {
                    sheetName: tab,
                    columns,
                    rows,
                    rowMergeCell,
                    filename: '检核验收结果'
                }
            })
        } else {
            return [{ sheetName: '预审核验收结果', rows: dataArray[0] }]
        }
    }

    _renderTitle = (data) => {
        let { title, type, onExport } = this.props
        return (
            <div className='card-title-row'>
                <Icon className='icon' type='switcher' />
                <div className='flex-sub'>{title}</div>
                {
                    type === 'look'
                        ? <WizButton className='export' onClick={() => onExport && onExport(data)}>{'导出'}</WizButton>
                        : null
                }
            </div>
        )
    }

    _onTab = (tab, i) => {
        this.setState({ index: i })
    }

    _renderTab = (tab, i) => {
        let className = i === this.state.index ? 'criteria-tab-item criteria-tab-active' : 'criteria-tab-item'
        return <div key={'result_tab_' + i} className={className} onClick={() => this._onTab(tab, i)}>{tab || ''}</div>
    }

    render() {
        let { data, other } = this.props
        let { tabs, index } = this.state
        let { columnsArray, columnsExportArray, dataArray } = this._convert(data, other)
        let columns = columnsArray[index]
        let dataSource = dataArray[index]
        let exportData = this._convertExportData({ columnsExportArray, dataArray, other, tabs, index })
        let tableProps = {
            columns,
            dataSource,
            pagination: false,
            bordered: true
        }
        return (
            <Card className='antui-card' title={this._renderTitle(exportData)}>
                {
                    other ?
                        <div className='pre-audit-criteria-row'>
                            <div className='criteria-tabs'>
                                {tabs.map((tab, i) => this._renderTab(tab, i))}
                            </div>
                        </div>
                        : null
                }
                <Table {...tableProps} />
            </Card>
        )
    }
}

export default AcceptanceResults


